import { useParams } from 'react-router-dom';
import { StatusLabel } from '@shared/components';
import { useInlineBlock } from '../api';
import InlineBlockContainer from '../components/InlineBlockContainer';

const InlineBlock = () => {
  const { id } = useParams(); // Access the dynamic part of the route
  const { error, data } = useInlineBlock(id as string); // id is always filled, otherwise NoPage.tsx is rendered
  return (
    <StatusLabel
      data={data}
      loadingMessage="Loading inline-block..."
      error={error}
      errorMessage="Loading inline-block failed!"
      render={(data) => (
        <InlineBlockContainer
          inlineBlock={data.inlineBlock}
          permissions={data.permissions}
          resolvedItems={data.resolvedItems}
        />
      )}
    />
  );
};

export default InlineBlock;
